"use strict";

export default function () {
  return {
    restrict: "A",
    template: require("../view/summary-charts.html"),
    scope: {
      defaultColors: "=defaultColors",

      countByIndustryData: "=countByIndustryData",
      countByIndustryLabels: "=countByIndustryLabels",
      countByIndustryOptions: "=countByIndustryOptions",
      countByIndustrySummary: "=countByIndustrySummary",
      countByIndustryUnit: "=countByIndustryUnit",

      fundBySrcCategoryData: "=fundBySrcCategoryData",
      fundBySrcCategoryLabels: "=fundBySrcCategoryLabels",
      fundBySrcCategoryOptions: "=fundBySrcCategoryOptions",
      fundBySrcCategorySummary: "=fundBySrcCategorySummary",
      fundBySrcCategoryUnit: "=fundBySrcCategoryUnit",

      fundByIndustryData: "=fundByIndustryData",
      fundByIndustryLabels: "=fundByIndustryLabels",
      fundByIndustryOptions: "=fundByIndustryOptions",
      fundByIndustrySummary: "=fundByIndustrySummary",
      fundByIndustryUnit: "=fundByIndustryUnit",

      projectByOivData: "=projectByOivData",
      projectByOivLabels: "=projectByOivLabels",
      projectByOivOptions: "=projectByOivOptions",
      projectByOivSummary: "=projectByOivSummary",
      projectByOivUnit: "=projectByOivUnit",

      projectByTypeData: "=projectByTypeData",
      projectByTypeLabels: "=projectByTypeLabels",
      projectByTypeOptions: "=projectByTypeOptions",
      projectByTypeSummary: "=projectByTypeSummary",
      projectByTypeUnit: "=projectByTypeUnit",

      workPlaceByIndustryData: "=workPlaceByIndustryData",
      workPlaceByIndustryLabels: "=workPlaceByIndustryLabels",
      workPlaceByIndustryOptions: "=workPlaceByIndustryOptions",
      workPlaceByIndustrySummary: "=workPlaceByIndustrySummary",
      workPlaceByIndustryUnit: "=workPlaceByIndustryUnit",
    },
    controller: [
      "$scope",
      "ChartOptionsService",
      ($scope, ChartOptionsService) => {
        $scope.charts = [
          {
            id: "summary_investVolumeByIndustry",
            name: "Объем инвестиций",
            description: "По отраслям",
          },
          {
            id: "summary_projectsByIndustry",
            name: "Проекты",
            description: "По отраслям",
          },
          {
            id: "summary_projectsByManager",
            name: "Проекты",
            description: "По ответственным РОИВ",
          },
          {
            id: "summary_projectsByCount",
            name: "Проекты",
            description: "ВСЕГО",
          },
          {
            id: "summary_projectsByWorkplaces",
            name: "Создано рабочих мест",
            description: "по отраслям",
          },
          {
            id: "summary_projectsByFinancing",
            name: "Объем инвестиций",
            description: "по источникам финансирования",
          },
        ];

        $scope.isShowLegenda1 = false;
        $scope.isShowLegenda2 = false;
        $scope.isShowLegenda3 = false;
        $scope.isShowLegenda4 = false;
        $scope.isShowLegenda5 = false;
        $scope.isShowLegenda6 = false;

        $scope.toggleLegenda1 = (_chartArray, _event, chart) => {
          if (!chart) {
            clearShowStatus();
          }

          $scope.isShowLegenda1 = !!chart;
          $scope.$apply();
        };

        $scope.toggleLegenda2 = (_chartArray, _event, chart) => {
          if (!chart) {
            clearShowStatus();
          }

          $scope.isShowLegenda2 = !!chart;
          $scope.$apply();
        };

        $scope.toggleLegenda3 = (_chartArray, _event, chart) => {
          if (!chart) {
            clearShowStatus();
          }

          $scope.isShowLegenda3 = !!chart;
          $scope.$apply();
        };

        $scope.toggleLegenda4 = (_chartArray, _event, chart) => {
          if (!chart) {
            clearShowStatus();
          }

          $scope.isShowLegenda4 = !!chart;
          $scope.$apply();
        };

        $scope.toggleLegenda5 = (_chartArray, _event, chart) => {
          if (!chart) {
            clearShowStatus();
          }

          $scope.isShowLegenda5 = !!chart;
          $scope.$apply();
        };

        $scope.toggleLegenda6 = (_chartArray, _event, chart) => {
          if (!chart) {
            clearShowStatus();
          }

          $scope.isShowLegenda6 = !!chart;
          $scope.$apply();
        };

        function clearShowStatus() {
          $scope.isShowLegenda1 = false;
          $scope.isShowLegenda2 = false;
          $scope.isShowLegenda3 = false;
          $scope.isShowLegenda4 = false;
          $scope.isShowLegenda5 = false;
          $scope.isShowLegenda6 = false;
        }
      },
    ],
  };
}
